import axios from "axios";
const local = "http://localhost:5000";


let api_url = "";

if (process.env.NODE_ENV === "production") {
  api_url = process.env.REACT_APP_API_URL;
} else {
  api_url = local;
}
const api = axios.create({ baseURL: `${api_url}/api` });

// Si existe token en localStorage, añadir Authorization header por defecto
const storedToken = localStorage.getItem("customerToken");
if (storedToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
}
export default api;
